import CtaBuilderComponent from '../Cta';
import { overrideBuilderModel } from '../utils';
export var overrides = {
  inputs: [{
    name: 'text',
    type: 'string',
    defaultValue: 'SHOP NOW',
    localized: true
  }, {
    name: 'variant',
    type: 'string',
    "enum": [{
      label: 'Primary Dark',
      value: 'primaryDark'
    }, {
      label: 'Primary Light',
      value: 'primaryLight'
    }, {
      label: 'Primary Lavender',
      value: 'primaryLavender'
    }, {
      label: 'Secondary Dark',
      value: 'secondaryDark'
    }, {
      label: 'Secondary Light',
      value: 'secondaryLight'
    }, {
      label: 'Secondary Lavender',
      value: 'secondaryLavender'
    }, {
      label: 'Tertiary Dark',
      value: 'tertiaryDark'
    }, {
      label: 'Tertiary Light',
      value: 'tertiaryLight'
    }, {
      label: 'Primary (deprecated)',
      value: 'primary'
    }, {
      label: 'Secondary (deprecated)',
      value: 'secondary'
    }, {
      label: 'Alternate (deprecated)',
      value: 'alternate'
    }, {
      label: 'White (deprecated)',
      value: 'white'
    }],
    defaultValue: 'primaryDark'
  }, {
    name: 'link',
    type: 'string',
    defaultValue: '',
    localized: true
  }, {
    name: 'enableTracking',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'trackingData',
    type: 'object',
    subFields: [{
      name: 'category',
      type: 'string',
      required: true
    }, {
      name: 'title',
      type: 'string',
      required: true
    }],
    showIf: function showIf(options) {
      return options.get('enableTracking') === true;
    }
  }],
  defaultStyles: {
    width: 'fit-content',
    textTransform: 'uppercase'
  }
};
var SXFCtaBuilderComponent = overrideBuilderModel({
  base: CtaBuilderComponent,
  overrides: overrides
});
export default SXFCtaBuilderComponent;